import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import HeaderWithSearch from '../components/HeaderWithSearch'
import HorizontalEventMenu from '../components/HorizontalEventMenu'
import Time from '../components/Time'
import EventContent from '../components/EventContent'
import { Query } from 'react-apollo'
import { EVENT_OF_CURRENT_DAY, REFUEL_EVENT } from '../query/event'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  getTrackableIds,
  getFleetById,
  getSensorIds
} from '../utils/trackable'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getProduct
} from '../utils/helper'
import { omegaClient } from '../graphql/omegaClient'

class Event extends React.Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.pollingInterval = null
    this.state = {
      loadingTrb: true,
      keySearch: null,
      refuelEvents: [],
      sensorIds: [],
      trackables: []
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var product = this.props.match.params.product_id
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(async function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token')).then(function () {
              var newToken = localStorage.getItem('token')
              getUserInfo(newToken)
                .then(response => response.json())
                .then(async function (data) {
                  var products = data.data.attributes.products.fuel_sensor
                  if (getProduct(products, product).length > 0) {
                    var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
                    localStorage.setItem('fleet_id', fleetId)
                    var fleet = await getFleetById(fleetId)
                    if (fleet) {
                      localStorage.setItem('endpoint', product)
                      let trackables = fleet.trackables
                      let fleetName = fleet.name
                      localStorage.setItem('fleetName', fleetName)
                      const sensorIds = getSensorIds(trackables)

                      self.setState({
                        trackables: trackables,
                        sensorIds: sensorIds
                      }, () => {
                        // Fetch data immediately after state is set
                        self.fetchData()

                        // Set up polling every 1 minute (60000ms)
                        self.pollingInterval = setInterval(() => {
                          self.fetchData()
                        }, 60000)
                      })
                    } else document.location.href = '/#/error'
                  } else document.location.href = '/#/error'
                })
                .catch((error) => {
                  console.log('error: ', error)
                })
            })
          } else {
            var products = data.data.attributes.products.fuel_sensor
            if (getProduct(products, product).length > 0) {
              var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
              localStorage.setItem('fleet_id', fleetId)
              var fleet = await getFleetById(fleetId)
              if (fleet) {
                localStorage.setItem('endpoint', product)
                let trackables = fleet.trackables
                let fleetName = fleet.name
                localStorage.setItem('fleetName', fleetName)
                const sensorIds = getSensorIds(trackables)

                self.setState({
                  trackables: trackables,
                  sensorIds: sensorIds
                }, () => {
                  // Fetch data immediately after state is set
                  self.fetchData()

                  // Set up polling every 1 minute (60000ms)
                  self.pollingInterval = setInterval(() => {
                    self.fetchData()
                  }, 60000)
                })
              } else document.location.href = '/#/error'
            } else document.location.href = '/#/error'
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  fetchData () {
    this.refuelEvents(this.state.sensorIds)
      .then((refuelEvents) => {
        if (this._isMounted) {
          this.setState({
            refuelEvents,
            loadingTrb: false
          })
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  getSensorIds () {
    return getSensorIds(this.state.trackables)
  }

  refuelEvents (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  componentWillUnmount () {
    this._isMounted = false
    // Clear interval to prevent memory leaks
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }

  render () {
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu
                  enabled='event'
                />
              </td>
              <td style={styles.content}>
                <HeaderWithSearch
                  title='Evénements'
                  getKeySearch={(key) => this.setState({ keySearch: key })}
                />
                <HorizontalEventMenu
                  enabled='all'
                />
                {this.state.loadingTrb ? <CircularProgress
                  style={styles.progressStyle}
                  color='inherit'
                /> : <EventContent
                  route='Event'
                  events={this.state.refuelEvents}
                  trackables={this.state.trackables}
                  sensorIds={this.state.sensorIds}
                  keySearch={this.state.keySearch}
                />
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  progressStyle: {
    marginTop: '50px',
    color: '#7ED321'
  }
}

export default Event
